const TypeQualificationCXPI = ['CQPRncp', 'DiplomeEtat', 'TitreProfessionnel', 'CertificatCompetencePro', 'CertificatClea', 'BlocClea', 'CertificationRS', 'QualificationCC'] as const
const TypeQualificationExtensionCIPI = ['AttestationCapacite'] as const

export const TypeQualificationCIPI = [...TypeQualificationExtensionCIPI, ...TypeQualificationCXPI] as const
export type TypeQualificationCIPI = typeof TypeQualificationCIPI[number]

export const TypeQualificationCDPI = [...TypeQualificationCXPI] as const
export type TypeQualificationCDPI = typeof TypeQualificationCDPI[number]

export type TypeQualification = TypeQualificationCDPI | TypeQualificationCIPI

export const TypeQualificationLibelle: Record<TypeQualification, string> = {
  AttestationCapacite: 'Attestation de capacité',
  CQPRncp: 'Certificat de Qualification Professionnelle inscrit au RNCP',
  DiplomeEtat: 'Diplôme d\'état',
  TitreProfessionnel: 'Titre Professionnel',
  CertificatCompetencePro: 'Certificat de compétences professionnelles',
  CertificatClea: 'Certificat CléA',
  BlocClea: 'Bloc de compétence CléA',
  CertificationRS: 'Certification inscrite au répertoire spécifique',
  QualificationCC: 'Qualification reconnue par une convention collective',
} as const
